import {
	EDIT_MODULE,
	EDIT_MODULE_SUCCESS,
	EDIT_MODULE_FAIL,
	EDIT_MODULE_RESET,
} from '../actions/editModuleAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const editModuleReducer = (state = initialState, action) => {
	switch (action.type) {
		case EDIT_MODULE:
			return {
				...state,
				apiState: 'loading',
			};
		case EDIT_MODULE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case EDIT_MODULE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case EDIT_MODULE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default editModuleReducer;
